import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import WhizLayout from "./components/WhizLayout/WhizLayout";
import ResetPassword from "./views/sessions/ResetPassword";
import materialRoutes from "app/views/material-kit/MaterialRoutes";
//Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
import InitiativeApproval from "./views/sessions/InitiativeApproval";
import { EditPageWrapper } from "app/views/InitiativeManagement/Edit/EditPage";
//End of Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval

// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));

const JwtRegister = Loadable(
  lazy(() => import("app/views/sessions/JwtRegister"))
);
const UnauthorizedPage = Loadable(
  lazy(() => import("app/views/UnauthorizedPage"))
);
// E-CHART PAGE
const AppEchart = Loadable(
  lazy(() => import("app/views/charts/echarts/AppEchart"))
);
const ActionItems = Loadable(
  lazy(() => import("app/views/Action/ActionItems"))
);
const CompletedInitiativesList = Loadable(
  lazy(() => import("app/views/CompletedInitiativesList/CompletedInitiatives"))
);
const LoadingPage = Loadable(lazy(() => import("app/views/LoadingPage")));
const EditPage = Loadable(
  lazy(() => import("app/views/InitiativeManagement/Edit/EditPage"))
);
const ConvertedInitiatives = Loadable(
  lazy(() => import("app/views/ConvertedInitiatives/ConvertedInitiatives"))
);
const ProfilePage = Loadable(lazy(() => import("app/views/Profile/Profile")));
const InitiativeStatusManagement = Loadable(
  lazy(() => import("app/views/InitiativeStatusManagement/index"))
);
const UnderConstruction = Loadable(
  lazy(() => import("app/views/UnderConstruction"))
);
const Warehouse = Loadable(lazy(() => import("app/views/Warehouse/Warehouse")));
// const ExternalAudit = Loadable(lazy(() => import("app/views/ExternalAudit")));
const WithdrawnInitiatives = Loadable(
  lazy(() => import("app/views/WithdrawnInitiatives/WithdrawnInitiatives"))
);
const Reallocation = Loadable(lazy(() => import("app/views/Reallocation")));
// const Currency = Loadable(lazy(() => import("app/views/Currency")));
// const Country = Loadable(
//   lazy(() => import("app/views/Country/CountryInformation"))
// );
const WatchList = Loadable(
  lazy(() => import("app/views/WatchListConfiguration/WatchListConfiguration"))
);
// const DocumentsCategory = Loadable(
//   lazy(() => import("app/views/DocumentsCategory/DocCategory"))
// );
// const DepartmentMaster = Loadable(
//   lazy(() => import("app/views/DepartmentMaster/DepartmentMaster"))
// );

// DASHBOARD PAGE
const Analytics = Loadable(lazy(() => import("app/utils/Analytics")));
// const InitiativePrioritization = Loadable(
//   lazy(() => import("app/views/InitiativePrioritization"))
// );
const InitiativeManagement = Loadable(
  lazy(() => import("app/views/InitiativeManagement/InitiativeManagement"))
);
// const InitiativeConversion = Loadable(
//   lazy(() => import("app/views/InitiativeConversion"))
// );
// const InitiativeProgress = Loadable(
//   lazy(() => import("app/views/InitiativeProgress"))
// );
// const ManComPrioritization = Loadable(
//   lazy(() => import("app/views/ManComPrioritization"))
// );
const InitiativeLinking = Loadable(
  lazy(() => import("app/views/InitiativeTracking/InitiativeLinking"))
);

// Path Changed By Madhuri.Kon12-05-2025 comment start here
// Uncommented By Madhuri.K On 10-06-2025
const InitiativeConversion = Loadable(lazy(() => import("app/views/InitiativeTracking/InitiativeConversion")));
const InitiativeProgress = Loadable(lazy(() => import("app/views/InitiativeTracking/InitiativeProgress")));
const ManComPrioritization = Loadable(lazy(() => import("app/views/InitiativeTracking/ManComPrioritization")));
const InitiativePrioritization = Loadable(lazy(() => import("app/views/InitiativeTracking/InitiativePrioritization")));
// Path Changed By Madhuri.Kon12-05-2025 comment end here

const Program = Loadable(lazy(() => import("app/views/Program")));
// const ProjectMain = Loadable(lazy(() => import("app/views/ProjectMain")));
const LandingPage = Loadable(lazy(() => import("app/views/LandingPage")));
const ProgramList = Loadable(
  lazy(() => import("app/views/Programs/ProgramList/index"))
);
const ProjectList = Loadable(
  lazy(() => import("app/views/Programs/ProjectList/index"))
);
const MilestoneProgress = Loadable(
  lazy(() => import("app/views/Programs/MilestoneProgress"))
);
// const UpdateActualCost = Loadable(
//   lazy(() => import("app/views/Programs/UpdateActualCost/UpdateActualCost"))
// );
const InitiativeReport = Loadable(
  lazy(() => import("app/views/Reports/InitiativeReport"))
);
const ActionItemsReport = Loadable(
  lazy(() => import("app/views/Reports/ActionItemsReport"))
);
const ChangeNOIReport = Loadable(
  lazy(() => import("app/views/Reports/ChangeNOIReport"))
);
const ProgramTrackingReport = Loadable(
  lazy(() =>
    import("app/views/Reports/ProgramTrackingReport/ProgramTrackingReport")
  )
);
const DelayedInitiativeReport = Loadable(
  lazy(() => import("app/views/Reports/DelayedInitiativeReport"))
);
const DeliveryCalendarReport = Loadable(
  lazy(() => import("app/views/Reports/DeliveryCalendarReport"))
);
const AgeingReport = Loadable(
  lazy(() => import("app/views/Reports/AgeingReport"))
);
const InitiativeDashboard = Loadable(
  lazy(() => import("app/views/E-Dashboard/InitiativeDashboard"))
);

// Configuaration Module Routes Added by Gauri on 02 Sep 2025
const OrganizationStructure = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/OrganizationStructure")));
const BusinessGroup = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/BusinessGroup")));
const InitiativeCressRanges = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeCressRanges")));
const SystemEmailMessageMaster = Loadable(
  lazy(() => import("app/views/Configuration/SystemEmailMessageMaster"))
);
const FrameworkEmailMessage = Loadable(
  lazy(() => import("app/views/Configuration/FrameworkEmailMessage"))
);
// const NodeMaintenance = Loadable(
//   lazy(() => import("app/views/Configuration/SecurityNode/NodeMaintenance"))
// );
// const UserGroupAccess = Loadable(
//   lazy(() => import("app/views/Configuration/SecurityNode/UserGroupAccess"))
// );
const PasswordManagement = Loadable(
  lazy(() => import("app/views/Configuration/SecurityNode/PasswordManagement"))
);
const NatureOfInitiative = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/NatureOfInitiative")));
const ChecklistMakerInbox = Loadable(lazy(() => import("app/views/Configuration/ChecklistNode/ChecklistMakerInbox")));
const OrganizationUnit = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/OrganizationUnit")));
const DeliveryUnit = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/DeliveryUnit")));
const CompanyInformation = Loadable(lazy(() => import("app/views/Configuration/CompanyInformation")));
const CorporateSettings = Loadable(lazy(() => import("app/views/Configuration/CorporateSettings")));
// End of Configuaration Module Routes Added by Gauri on 02 Sep 2025

// const BusinessUserTracking = Loadable(
//   lazy(() => import("app/views/E-Dashboard/BusinessUserTracking/BusinessUserTracking"))
// );
const ExternalAudit = Loadable(lazy(() => import("app/views/ExternalAudits")));
const Snooze = Loadable(lazy(() => import("app/views/Snooze")));
// Comment start here Configuration pages path added here added By Madhuri.K on-01-09-2025
const ProjectStatus = Loadable(lazy(() => import("app/views/Configuration/ProjectsNode/ProjectStatus/ProjectStatus")));
const ProjectGroup = Loadable(lazy(() => import("app/views/Configuration/ProjectsNode/ProjectGroup/ProjectGroup")));
const ProjectType = Loadable(lazy(() => import("app/views/Configuration/ProjectsNode/ProjectType/ProjectType")));
const ProjectSizeUnits = Loadable(lazy(() => import("app/views/Configuration/ProjectsNode/ProjectSizeUnit/ProjectSizeUnit")));
const BusinessFeasibility = Loadable(lazy(() => import("app/views/Configuration/BusinessMastersNode/BusinessFeasibility/BusinessFeasibility")));
const BusinessImpact = Loadable(lazy(() => import("app/views/Configuration/BusinessMastersNode/BusinessImpact/BusinessImpact")));
const BusinessValue = Loadable(lazy(() => import("app/views/Configuration/BusinessMastersNode/BusinessValue/BusinessValue")));
const Priority = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/Priority/Priority")));
const CostCategory = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/CostCategory/CostCategory")));
const RiskCategories = Loadable(lazy(() => import("app/views/Configuration/RiskCategories")));
const RiskMatrixDefinition = Loadable(lazy(() => import("app/views/Configuration/RiskMatrixDefinition")));
const ActionStatus = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/ActionStatus/ActionStatus")));
const ActionPriority = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/ActionPriority/ActionPriority")));
const BusinessStrategy = Loadable(lazy(() => import("app/views/Configuration/BusinessMastersNode/BusinessStrategy/BusinessStrategy")));
const Skills = Loadable(lazy(() => import("app/views/Configuration/GeneralInformationNode/Skills/Skill")));
const AuditTypeDefinition = Loadable(lazy(() => import("app/views/Configuration/GeneralInformationNode/AuditTypeDefinition/AuditTypeDefinition")));
const DepartmentMaster = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/DepartmentMaster/DepartmentMaster")));
const InitiativeCategory = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeCategory/InitiativeCategory")));
const ResourceApproach = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/ResourceApproach/ResourceApproach")));
const Country = Loadable(lazy(() => import("app/views/Configuration/GeneralInformationNode/Country/Country")));
const InitiativeRelationTypeMaster = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeRelationType/InitiativeRelationType")));
const InitiativeStage = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeStage/InitiativeStage")));
const ChecklistItem = Loadable(lazy(() => import("app/views/Configuration/ChecklistNode/ChecklistItem/ChecklistItem")));
const Currency = Loadable(lazy(() => import("app/views/Configuration/GeneralInformationNode/Currency/Currency")));
const ChecklistSection = Loadable(lazy(() => import("app/views/Configuration/ChecklistNode/ChecklistSection/ChecklistSection")));
const Practice = Loadable(lazy(() => import("app/views/Configuration/ProjectsNode/Practice/Practice")));
const ChecklistMaker = Loadable(lazy(() => import("app/views/Configuration/ChecklistNode/ChecklistMaker/ChecklistMaker")));
const DocumentsCategory = Loadable(lazy(() => import("app/views/Configuration/GeneralInformationNode/DocumentsCategory/DocumentsCategory")));
const UnlockUser = Loadable(lazy(() => import("app/views/Configuration/SecurityNode/UnlockUser/UnlockUser")));
const UserGroup = Loadable(lazy(() => import("app/views/Configuration/SecurityNode/UserGroup/UserGroup")));
const InitiativeAccess = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeAccess/InitiativeAccess")));
const ProjectHealthSheetApproval = Loadable(lazy(() => import("app/views/Programs/ProjectHealthSheetApproval/ProjectHealthSheetApproval")));
const Vendor = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/Vendor/Vendor")));
const DeliveryTeam = Loadable(lazy(() => import("app/views/Configuration/OrganizationNode/DeliveryTeam/DeliveryTeam")));
const UserLoginMaintenance = Loadable(lazy(() => import("app/views/Configuration/SecurityNode/UserLoginMaintenance/UserLoginMaintenance")));
const VendorLoginMaintenance = Loadable(lazy(() => import("app/views/Configuration/SecurityNode/VendorLoginMaintenance/VendorLoginMaintenance")));
const ProcessInformation = Loadable(lazy(() => import("app/views/Configuration/BusinessMastersNode/ProcessInformation/ProcessInformation")));
const InitiativeCorporateFields = Loadable(lazy(() => import("app/views/Configuration/InitiativeMastersNode/InitiativeCorporateFields/InitiativeCorporateFields")));
const Role_Maintenance = Loadable(lazy(() => import("app/views/Configuration/Role_Maintenance/Role_Maintenance")));
const UserMaintenance = Loadable(lazy(() => import("app/views/Configuration/SecurityNode/UserMaintenance/UserMaintenance")));
const PrioritizationChecklist = Loadable(lazy(() => import("app/views/Configuration/ChecklistNode/PrioritizationChecklist/PrioritizationChecklist")));
const RoleAccess = Loadable(
  lazy(() => import("app/views/Configuration/SecurityNode/RoleAccess"))
);
// Comment end here Configuration pages path added here added By Madhuri.K on-01-09-2025
const routes = [
  {
    element: (
      <AuthGuard>
        <WhizLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      // dashboard route
      { path: "/analytics", element: <Analytics />, auth: authRoles.admin },
      {
        path: "/InitiativeManagement",
        element: <InitiativeManagement />,
        auth: authRoles.admin,
      },
      {
        path: "/InitiativeManagement/:id",
        element: <EditPageWrapper />,
        auth: authRoles.admin,
      },
      { path: "/Warehouse", element: <Warehouse /> },
      {
        path: "/CompletedInitiativesList",
        element: <CompletedInitiativesList />,
      },
      { path: "/ConvertedInitiatives", element: <ConvertedInitiatives /> },
      { path: "/WithdrawnInitiatives", element: <WithdrawnInitiatives /> },
      {
        path: "/InitiativeStatusManagement",
        element: <InitiativeStatusManagement />,
      },
      { path: "/page-layouts/user-profile", element: <ProfilePage /> },
      {
        path: "/InitiativePrioritization",
        element: <InitiativePrioritization />,
      },
      // { path: "/ExternalAudit", element: <ExternalAudit /> },
      { path: "/ActionItems", element: <ActionItems /> },
      { path: "/WatchListConfiguration", element: <WatchList /> },
      {
        path: "/under-construction",
        element: <UnderConstruction />,
      },
      { path: "/InitiativeProgress", element: <InitiativeProgress /> },
      { path: "/InitiativeConversion", element: <InitiativeConversion /> },
      { path: "/ManComPrioritization", element: <ManComPrioritization /> },
      { path: "/InitiativeLinking", element: <InitiativeLinking /> },
      { path: "/Program", element: <Program /> },
      { path: "/Reallocation", element: <Reallocation /> },
      // { path: "/ProjectMain", element: <ProjectMain /> },

      { path: "/edit/:id", element: <EditPage /> },
      { path: "/Currency", element: <Currency /> },
      { path: "/Skills", element: <Skills /> },
      { path: "/Country", element: <Country /> },
      { path: "/AuditTypeDefinition", element: <AuditTypeDefinition /> },
      { path: "/DocumentsCategory", element: <DocumentsCategory /> },
      { path: "/DepartmentMaster", element: <DepartmentMaster /> },
      { path: "/", element: <LandingPage /> },
      { path: "/landingPage", element: <LandingPage /> },
      { path: "/programlist", element: <ProgramList /> },
      { path: "/projectlist", element: <ProjectList /> },
      { path: "/milestoneprogress", element: <MilestoneProgress /> },
      // { path: "/UpdateActualCost", element: <UpdateActualCost /> },
      { path: "/InitiativeReport", element: <InitiativeReport /> },
      { path: "/ActionItemsReport", element: <ActionItemsReport /> },
      { path: "/ChangeNOIReport", element: <ChangeNOIReport /> },
      { path: "/ProgramTrackingReport", element: <ProgramTrackingReport /> },
      {
        path: "/DelayedInitiativeReport",
        element: <DelayedInitiativeReport />,
      },
      { path: "/DeliveryCalendarReport", element: <DeliveryCalendarReport /> },
      { path: "/AgeingReport", element: <AgeingReport /> },
      { path: "/InitiativeDashboard", element: <InitiativeDashboard /> },

      // Configuaration Module Routes Added by Gauri on 02 Sep 2025
      { path: "/InitiativeCressRanges", element: <InitiativeCressRanges /> },
      { path: "/OrganizationStructure", element: <OrganizationStructure /> },
      { path: "/BusinessGroup", element: <BusinessGroup /> },
      { path: "/SystemEmailMessageMaster", element: <SystemEmailMessageMaster /> },
      { path: "/FrameworkEmailMessage", element: <FrameworkEmailMessage /> },
      // { path: "/NodeMaintenance", element: <NodeMaintenance /> },
      // { path: "/UserGroupAccess", element: <UserGroupAccess /> },
      { path: "/PasswordManagement", element: <PasswordManagement /> },
      { path: "/NatureOfInitiative", element: <NatureOfInitiative /> },
      { path: "/ChecklistMakerInbox", element: <ChecklistMakerInbox /> },
      { path: "/OrganizationUnit", element: <OrganizationUnit /> },
      { path: "/DeliveryUnit", element: <DeliveryUnit /> },
      { path: "/CompanyInformation", element: <CompanyInformation /> },
      { path: "/CorporateSettings", element: <CorporateSettings /> },
      // Configuration Module Routes Added by Gauri on 02 Sep 2025

      // { path: "/BusinessUserTracking", element: <BusinessUserTracking /> },
      { path: "/ExternalAudit", element: <ExternalAudit /> },
      { path: "/Snooze", element: <Snooze /> },
      // Configuration Module Added By Madhuri.k on 01-09-2025
      { path: "/ProjectStatus", element: <ProjectStatus /> },
      { path: "/ProjectGroup", element: <ProjectGroup /> },
      { path: "/ProjectType", element: <ProjectType /> },
      { path: "/ProjectSizeUnits", element: <ProjectSizeUnits /> },
      { path: "/BusinessFeasibility", element: <BusinessFeasibility /> },
      { path: "/BusinessImpact", element: <BusinessImpact /> },
      { path: "/BusinessValue", element: <BusinessValue /> },
      { path: "/Priority", element: <Priority /> },
      { path: "/CostCategory", element: <CostCategory /> },
      { path: "/RiskCategories", element: <RiskCategories /> },
      { path: "/RiskMatrixDefinition", element: <RiskMatrixDefinition /> },
      { path: "/ActionStatus", element: <ActionStatus /> },
      { path: "/ActionPriority", element: <ActionPriority /> },
      { path: "/BusinessStrategy", element: <BusinessStrategy /> },
      { path: "/InitiativeCategory", element: <InitiativeCategory /> },
      { path: "/ResourceApproach", element: <ResourceApproach /> },
      { path: "/InitiativeRelationTypeMaster", element: <InitiativeRelationTypeMaster /> },
      { path: "/InitiativeStage", element: <InitiativeStage/> },
      { path: "/ChecklistItem", element: <ChecklistItem /> },
      { path: "/ChecklistSection", element: <ChecklistSection /> },
      { path: "/Practice", element: <Practice /> },
      { path: "/ChecklistMaker", element: <ChecklistMaker /> },
      { path: "/UnlockUser", element: <UnlockUser /> },
      { path: "/UserGroup", element: <UserGroup /> },
      { path: "/InitiativeAccess", element: <InitiativeAccess /> },
      { path: "/ProjectHealthSheetApproval", element: <ProjectHealthSheetApproval/> },
      { path: "/Vendor", element: <Vendor/> }, 
      { path: "/DeliveryTeam", element: <DeliveryTeam/> }, 
      { path: "/UserLoginMaintenance", element: <UserLoginMaintenance /> },
      { path: "/VendorLoginMaintenance", element: <VendorLoginMaintenance /> },
      { path: "/ProcessInformation", element: <ProcessInformation /> },
      { path: "/InitiativeCorporateFields", element: <InitiativeCorporateFields /> },
      { path: "/Role_Maintenance", element: <Role_Maintenance/> },
      { path: "/UserMaintenance", element: <UserMaintenance /> },
      { path: "/PrioritizationChecklist", element: <PrioritizationChecklist /> },
      { path: "/RoleAccess", element: <RoleAccess /> },
         // Configuration Module Added By Madhuri.k on 01-09-2025
    ],  
  },

  // session pages route
  { path: "/LoadingPage", element: <LoadingPage /> },
  { path: "/session/404", element: <NotFound /> },
  { path: "/signin", element: <JwtLogin /> },
  { path: "/signup", element: <JwtRegister /> },
  { path: "/reset-password", element: <ResetPassword /> },
  //Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
  { path: "/InitiativeApproval", element: <InitiativeApproval /> },
  //End of Added by Aditya J. on 04-07-2025 for Initiative Email Base Approval
  { path: "/UnauthorizedPage", element: <UnauthorizedPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
